module.exports = __webpack_public_path__ + "static/media/onboardingSuccess.b46b23c2.png";